import type { ArtPal } from './covers/kit';

/** One avatar face: accent colour + markup (128×128, clipped to the central circle by avatarMarkup). */
export interface AvatarFace {
  c: (P: ArtPal) => string;
  draw: (P: ArtPal, p: string, c: string) => string;
}

/** Dark ink for eyes / mouths (never pure black). */
export const ink = (P: ArtPal) => (P.dark ? P.bg : '#111827');

export const eye = (x: number, y: number, r: number, P: ArtPal) =>
  `<circle cx="${x}" cy="${y}" r="${r}" fill="${ink(P)}"/><circle cx="${x - r * 0.35}" cy="${y - r * 0.35}" r="${r * 0.36}" fill="#FFFFFF"/>`;
export const smile = (x: number, y: number, w: number, P: ArtPal) =>
  `<path d="M${x - w} ${y}Q${x} ${y + w * 0.8} ${x + w} ${y}" fill="none" stroke="${ink(P)}" stroke-width="3.5" stroke-linecap="round"/>`;
export const cheeks = (y: number, P: ArtPal) =>
  `<ellipse cx="38" cy="${y}" rx="7" ry="4" fill="${P.pink}" fill-opacity=".45"/><ellipse cx="90" cy="${y}" rx="7" ry="4" fill="${P.pink}" fill-opacity=".45"/>`;
